import 'firebase/remote-config';
import firebase from './firebase';

const remoteConfig = firebase.remoteConfig();

const minimumFetchIntervalMillis =
  process.env.NODE_ENV === 'production' ? 3600000 : 60;

remoteConfig.settings = {
  minimumFetchIntervalMillis
};

export async function getRemoteConfigValue(remoteConfigKey) {
  try {
    await remoteConfig.fetchAndActivate();
    return remoteConfig.getString(remoteConfigKey);
  } catch (error) {
    return null;
  }
}
export default remoteConfig;